<svg
  width="262"
  height="29"
  viewBox="0 0 262 29"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$restProps.class}
  style={$$restProps.style}
>
  <g clip-path="url(#clip0_444_8020)">
    <path
      d="M7.62256 13.4883C13.2985 9.4458 24.5757 10.1348 30.9173 9.56413C46.2252 8.18656 61.7499 6.63032 77.1325 6.64814C109.631 6.68579 141.796 9.70044 174.231 11.0434C195.492 11.9237 216.785 13.5086 238.043 13.2977C242.495 13.2536 248.302 12.4128 252.38 14.0822"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_444_8020">
      <rect width="262" height="29" fill="white" />
    </clipPath>
  </defs>
</svg>
